<template>
    <History :items="this.$store.state.eyprData.history.states" />
</template>

<script>
import History from '$Components/History';

export default {
    name: 'EyprDataHistory',

    components: {
        History,
    },

    props: {
        eyprDataId: { type: [String, Number], required: true },
        formDisabled: { type: Boolean, default: false },
        // applicationId: { type: [String, Number], required: true },
    },

    async mounted() {
        this.$store.dispatch('eyprData/history/fetch', {
            // applicationId: this.applicationId,
            eyprDataId: this.eyprDataId,
        });
    },
};
</script>
